import { createListenerMiddleware } from "@reduxjs/toolkit";
import { isAnyOf } from "@reduxjs/toolkit";

import { api } from "src/store/api";
import { coreActions, errorActions, v3Actions } from "src/store/slices";
import { getGameId, getNextId, getViewId } from "src/selectors";
import { RootState } from "src/types";
import { socketActions } from "src/store/actions";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  effect: async (_, api) => {
    await api.delay(4000).then(() => {
      api.dispatch(errorActions.errorMessageUpdated(""));
      api.dispatch(errorActions.errorTypeUpdated(null));
    });
  },
  matcher: isAnyOf(
    api.endpoints.betCreate.matchFulfilled,
    api.endpoints.betCreate.matchRejected
  ),
});

listenerMiddleware.startListening({
  effect: async (_, api) => {
    const state = api.getState() as RootState;

    const nextId = getNextId(state);

    api.dispatch(v3Actions.viewIdUpdated(nextId));
  },
  matcher: isAnyOf(
    api.endpoints.betCreate.matchPending,
    coreActions.betsUpdated,
    coreActions.betsUndo,
    socketActions.messageInit
  ),
});

listenerMiddleware.startListening({
  effect: async (_, api) => {
    const state = api.getState() as RootState;

    const gameId = getGameId(state);
    const nextId = getNextId(state);
    const viewId = getViewId(state);

    const ms = gameId === viewId ? 2000 : 0;

    await api.delay(ms).then(() => {
      api.dispatch(v3Actions.viewIdUpdated(nextId));
    });
  },
  type: socketActions.messageStart.type,
});
